import { Box, useMediaQuery } from "@mui/material";
import { Container } from "@mui/system";
import { useContext, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import useCookies from "../../services/CookieService";
import { updateUserToken } from "../../utils/vwidService";

import ErrorBoundary from "../ErrorBoundary";
import Header from "../header";
import Sidebar from "../menu/Sidebar";
import { Unauthorized } from "../unauthorized";
import { LoadingSpinning } from "../loadingSpinning";

export default function Layout() {
  const { signIn, tokenHeaders, user, setTokenHeaders, loading } =
    useContext(AuthContext);
  const { findCookie } = useCookies();
  const navigate = useNavigate();
  const params = useParams();

  const url = window.location.href;
  const urlParse = url.replace("#", "?&");

  const accessToken = new URLSearchParams(urlParse).get("access_token") || "";
  const idToken = new URLSearchParams(urlParse).get("id_token") || "";
  const code = new URLSearchParams(urlParse).get("code") || "";
  console.log("🚀 ~ file: index.tsx:25 ~ Layout ~ code", code);
  const expiresIn = new URLSearchParams(urlParse).get("expires_in") || "";

  const userLogged = findCookie("isLogged");

  useEffect(() => {
    const verifyLogin = () => {
      console.log(`Verificando login ${new Date().toLocaleString("pt-BR")}`);
      const token = findCookie("accessToken");
      const loginStrategy = [
        {
          condition: !accessToken && !token && userLogged?.value !== "logged",
          action() {
            navigate("welcome");
          },
        },
        {
          condition: !userLogged,
          action() {
            signIn({ accessToken, idToken, code, expiresIn });
          },
        },
        {
          condition: !token && userLogged,
          action() {
            updateUserToken(setTokenHeaders);
          },
        },
      ];
      loginStrategy.find(({ condition }) => condition)?.action();
    };
    verifyLogin();
    const time = 5 * 60 * 1000;
    const interval = setInterval(() => {
      verifyLogin();
    }, time);

    return () => clearInterval(interval);
  });

  const matches = useMediaQuery("(min-width:900px)");

  if (window.location.pathname === "/") {
    navigate("home");
  }

  if (matches) {
    return (
      <>
        <Header />

        {loading ? (
          <Container
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "1250px" },
              px: { xs: 1.5, sm: 2, md: 3 },
              pt: "64px",
            }}
          >
            <LoadingSpinning />
          </Container>
        ) : user ? (
          <Box sx={{ display: "flex", pt: "64px" }}>
            <Sidebar />
            <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: 3 }}>
              <Container
                sx={{
                  width: "100%",
                  maxWidth: {
                    xs: "100%",
                    sm: "100%",
                    md: "100%",
                    lg: "1250px",
                  },
                  mx: "auto",
                  px: 0,
                }}
              >
                <ErrorBoundary>
                  <Outlet />
                </ErrorBoundary>
              </Container>
            </Box>
          </Box>
        ) : (
          <Container sx={{ pt: "64px" }}>
            <Unauthorized />
          </Container>
        )}
      </>
    );
  }

  return (
    <>
      <Header />

      <Container sx={{ px: { xs: 1.5, sm: 2 }, pt: "64px" }}>
        {user ? (
          <Box>
            {user && (
              <Box>
                <ErrorBoundary>
                  <Outlet />
                </ErrorBoundary>
              </Box>
            )}
            {/* <Outlet /> */}
          </Box>
        ) : (
          <p>Usuario sem permissao</p>
        )}
      </Container>
    </>
  );
}
